import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface UserListActionsHeaderProps
  extends HeaderContext<GatewayUserModel, unknown> {}

export const UserListActionsHeader = (): // props: UserListActionsHeaderProps,
ReactNode => {
  // RENDER ////////////////////////////////////////////////////////////////////

  return null;
};
